import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { forwardRef, useImperativeHandle, useRef } from "react";
import { gql } from "@apollo/client";
import { useWelcomeGiftVariantQuery } from "types";
import { ChooseSubscriptionScreen } from "@withfriendsco/wf-components";
gql `
query WelcomeGiftVariant($id: ID!) {
  fulfillment(id: $id) {
    id
    benefit {
      id
      name
    }
  }
}
`;
const WelcomeGiftVariant = forwardRef(({ id, onDeliveryMethodChange, isEmbedded, isAfterPurchase, isUserUpdateHandledByParent }, ref) => {
    const childRef = useRef(null);
    useImperativeHandle(ref, () => ({
        save: (address) => { var _a; return (_a = childRef.current) === null || _a === void 0 ? void 0 : _a.save(address); },
        checkRequiredFields: () => { var _a; return ((_a = childRef.current) === null || _a === void 0 ? void 0 : _a.checkRequiredFields()) || []; },
    }));
    const { data, loading, error } = useWelcomeGiftVariantQuery({
        variables: {
            id,
        }
    });
    if (loading || !data)
        return null;
    const headerText = _jsxs(_Fragment, { children: ["As a new member, you'll receive a ", _jsx("strong", { children: data.fulfillment.benefit.name }), " \u2013 a little welcome from us to you!"] });
    return (_jsx(ChooseSubscriptionScreen, { ref: childRef, id: id, isEmbedded: isEmbedded, onDeliveryMethodChange: onDeliveryMethodChange, headerText: headerText, hasWelcomeGift: true, isAfterPurchase: isAfterPurchase, isUserUpdateHandledByParent: isUserUpdateHandledByParent }));
});
export default WelcomeGiftVariant;
